"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStandards = void 0;
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var context_1 = require("../context");
var helpers_1 = require("../helpers");
var Common_1 = require("../../modules/Common");
var useStandards = function () {
    var _a = (0, react_1.useContext)(context_1.ServiceContext), standardService = _a.standardService, analyticsService = _a.analyticsService;
    var toast = (0, react_1.useContext)(Common_1.AtomicAlertManagerContext).toast;
    var t = (0, react_i18next_1.useTranslation)().t;
    var itemStandardsPerformanceByAssessmentTemplate = function (assessmentClass, templates, bands, standardHierarchyLevel, standardSetGlobalIds, mergeItemStandardsToTemplates) { return __awaiter(void 0, void 0, void 0, function () {
        var nonDiagnosticAssessmentTemplateIds, assessmentTemplateItemStandards_1, standardCodeFromItemStandard, assigneesStandardPerformanceData, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    nonDiagnosticAssessmentTemplateIds = templates.map(function (nonDiagnosticAssessmentTemplate) { return nonDiagnosticAssessmentTemplate.id; });
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, standardService.findByAssessmentTemplateId(nonDiagnosticAssessmentTemplateIds, {
                            standardSetGlobalIds: standardSetGlobalIds,
                            hierarchyLevels: [standardHierarchyLevel],
                        }, templates[0].curriculum // For now passing the first one
                        )];
                case 2:
                    assessmentTemplateItemStandards_1 = _a.sent();
                    if (mergeItemStandardsToTemplates) {
                        templates.forEach(function (template) {
                            var _a;
                            template.itemStandards = (_a = assessmentTemplateItemStandards_1.find(function (_a) {
                                var assessmentTemplateId = _a.assessmentTemplateId;
                                return assessmentTemplateId === template.id;
                            })) === null || _a === void 0 ? void 0 : _a.itemStandards;
                        });
                    }
                    standardCodeFromItemStandard = (0, helpers_1.getStandardCodeFromItemStandard)(assessmentTemplateItemStandards_1);
                    return [4 /*yield*/, analyticsService.getAssigneesStandardPerformanceByClassAndTemplate([assessmentClass], templates, bands, standardHierarchyLevel, standardCodeFromItemStandard.standards, standardCodeFromItemStandard.itemStandards)];
                case 3:
                    assigneesStandardPerformanceData = _a.sent();
                    return [2 /*return*/, {
                            standards: standardCodeFromItemStandard.standards,
                            itemStandards: standardCodeFromItemStandard.itemStandards,
                            assigneesStandardPerformanceData: assigneesStandardPerformanceData,
                        }];
                case 4:
                    error_1 = _a.sent();
                    toast({
                        alertVariant: 'error',
                        content: {
                            title: t('common.errorMessages.oopsErr'),
                            message: t('common.errorMessages.standardsData'),
                        },
                    });
                    return [2 /*return*/, {
                            standards: [],
                            itemStandards: [],
                            assigneesStandardPerformanceData: [],
                        }];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return {
        itemStandardsPerformanceByAssessmentTemplate: itemStandardsPerformanceByAssessmentTemplate,
    };
};
exports.useStandards = useStandards;
